import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonField } from '../models/Field';

@Component({
  selector: 'field-line',
  template: `<ng-container *ngFor="let field of column">
  <div
    [ngSwitch]="field.field.componentType"
    class="{{
      field.widthModifier ? 'col-xs-12 col-md-' + field.widthModifier : ''
    }}"
  >
    <textbox-1
      *ngSwitchCase="'textbox'"
      [form]="form"
      [field]="field.field"
      [allFormFields]="allFormFields"
    ></textbox-1>
    <dropdown-kendo
      *ngSwitchCase="'dropdown-kendo'"
      [form]="form"
      [field]="field.field"
    ></dropdown-kendo>
    <dropdown-combo-kendo
      *ngSwitchCase="'dropdown-combo-kendo'"
      [form]="form"
      [field]="field.field"
    ></dropdown-combo-kendo>
    <checkbox-1
      *ngSwitchCase="'checkbox'"
      [form]="form"
      [field]="field.field"
    ></checkbox-1>
    <date-picker-kendo
      *ngSwitchCase="'date-picker'"
      [form]="form"
      [field]="field.field"
    ></date-picker-kendo>
    <file-picker
      *ngSwitchCase="'file-picker'"
      [form]="form"
      [field]="field.field"
    ></file-picker>
    <mail-button
      *ngSwitchCase="'mail-button'"
      [form]="form"
      [field]="field.field"
    ></mail-button>
    <entity-picker
      *ngSwitchCase="'entity-picker'"
      [form]="form"
      [field]="field.field"
      [metadataName]="'ClientContacts'"
    ></entity-picker>
  </div>`,
})
export class FieldLineComponent {
  @Input() column;
  @Input() form: FormGroup;
  @Input() allFormFields: CommonField[];
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/field-line.component.ts